module.exports = __webpack_public_path__ + "img/20191121102535427.c48a8f44.png";